import React, { useState } from 'react';
import { Button, Checkbox, Typography } from 'seagull';
import { StepPage } from "../../components/StepPage";
import AccountantAccessLearnMoreButton from "../../../components/AccountantAccessLearnMoreButton";
import { RequestAccountantAccess } from "../../../models/request-accountant-access";
import { useCobStorage } from "../CobStorageContext";
import styles from "./AccountantAccessStep.module.scss";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
export default function AccountantAccessStep(props) {
  const {
    onDone,
    onBack
  } = props;
  const {
    relationship
  } = useCobConfig();
  const {
    getFromStorage,
    setToStorage
  } = useCobStorage(relationship);
  const [checked, setChecked] = useState(() => getFromStorage('request_accountant_access') || false);
  const isNextDisabled = relationship.requestAccountantAccess === RequestAccountantAccess.Mandatory && !checked;
  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.accountantAccess),
    primaryBtn: /*#__PURE__*/React.createElement(Button, {
      disabled: isNextDisabled,
      tooltip: {
        title: isNextDisabled ? 'To approve this proposal, Accountant Access permissions must be granted' : ''
      },
      "data-testid": "accountant-access-next-btn",
      onClick: onDone
    }, "Next"),
    onBackBtnClick: onBack
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "accountant-access-page",
    className: styles.container
  }, /*#__PURE__*/React.createElement(Typography, null, "Accountant Access will allow the ", relationship.vendor.name, " team to view your account information on Anchor, including invoices, agreements, and payments, as well as manage your payment methods."), /*#__PURE__*/React.createElement(Checkbox, {
    "data-testid": "accountant-access-checkbox",
    checked: checked,
    onChange: e => {
      const newChecked = e.target.checked;
      setChecked(newChecked);
      setToStorage('request_accountant_access', newChecked);
    }
  }, /*#__PURE__*/React.createElement(Typography, null, "I grant Accountant Access to ", relationship.vendor.name)), /*#__PURE__*/React.createElement(AccountantAccessLearnMoreButton, {
    isVendor: false
  })));
}